import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AddPanelExpandableSection from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/AddPanelExpandableSections';
import { getRecentModuleSpecsAsArray } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import ExpandableSectionBorderlessHeader from 'messaging-editing-lib/utilityUI/ExpandableSectionBorderlessHeader';
import RenderModules from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/RenderModules';
import { jsx as _jsx } from "react/jsx-runtime";
const RecentlyUsedModulesSection = () => {
  const recentlyUsedModules = useSelector(getRecentModuleSpecsAsArray);
  if (recentlyUsedModules.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(AddPanelExpandableSection, {
    name: "recently-used-modules-section",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.defaultModules.recentModules.header"
    }),
    Header: ExpandableSectionBorderlessHeader,
    indentation: "compact",
    removeRightPaddingFromContent: true,
    children: /*#__PURE__*/_jsx(RenderModules, {
      modules: recentlyUsedModules,
      withStoringInRecentlyUsed: false
    })
  });
};
export default RecentlyUsedModulesSection;